import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogModule, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { GameSession } from '../../../../core/models/game.model';
import { RouterLink } from '@angular/router';
import { TranslatePipe } from '../../../../shared/pipes/translate.pipe';
import { TranslationService } from '../../../../core/services/translation.service';
import { Observable, take } from 'rxjs';
import { langPart } from '../../../../core/helpers/navigation.helper';

@Component({
  selector: 'app-active-session-dialog',
  standalone: true,
  imports: [CommonModule, MatDialogModule, MatButtonModule, RouterLink, TranslatePipe],
  template: `
    <h2 mat-dialog-title>{{ 'active_session_dialog.title' | translate | async }}</h2>
    <mat-dialog-content>
      <p>{{ message$ | async }}</p>
      <p>
        <a [routerLink]="[langPart+'/playarea/room', data.currentSession.id]" (click)="dialogRef.close(false)">
          {{ 'active_session_dialog.go_to_active' | translate | async }}
        </a>
      </p>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-button (click)="dialogRef.close(false)">{{ 'general.buttons.cancel' | translate | async }}</button>
      <button mat-stroked-button color="warn" (click)="dialogRef.close(true)">{{ 'general.buttons.continue' | translate | async }}</button>
    </mat-dialog-actions>
  `,
  styles: [`
    a {
      color: #3f51b5;
      text-decoration: none;

      &:hover {
        text-decoration: underline;
      }
    }
  `]
})

export class ActiveSessionDialogComponent {
  message$: Observable<string>;
  langPart = '';
  constructor(
    public dialogRef: MatDialogRef<ActiveSessionDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { currentSession: GameSession },
    private translationService: TranslationService
  ) {
    this.message$ = this.translationService.translate('active_session_dialog.message', this.data.currentSession?.game?.title?.text || '');
    this.translationService.getCurrentLang().pipe(take(1)).subscribe(lang => {
      this.langPart = langPart(lang);
    });
  }
}
